module.exports = __webpack_public_path__ + "img/350.e5c73fea.svg";